import Call from '../Call';
import {objToQs} from '../Utils';

const AdKernel = {
    get(filters, type = '') {
        return Call(`adKernel/${type}?${objToQs(filters)}`);
    },

    getHourly(filters, path = '') {
        return Call(`adKernelHourly/${path}?${objToQs(filters)}`);
    },

    getDaily(filters, path = '') {
        return Call(`adKernelDaily/${path}?${objToQs(filters)}`);
    }
};

export default AdKernel;


// WEBPACK FOOTER //
// ./src/services/API/components/AdKernel.js